import { useEffect, useState } from 'react';
import { api, type Job } from '../lib/api';
import { StatusBadge } from '../components/JobToast';
import { formatDateTime } from '../lib/format';

export function JobsPage() {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    const data = await api.get<{ jobs: Job[] }>('/api/jobs');
    setJobs(data.jobs);
  };

  useEffect(() => {
    void load().catch((e) => setError(e instanceof Error ? e.message : 'Laden mislukt'));
    const t = setInterval(() => {
      void load().catch(() => undefined);
    }, 2000);
    return () => clearInterval(t);
  }, []);

  return (
    <div>
      <h1>Jobs</h1>
      <p className="page-lead">
        Overzicht van achtergrondtaken (inladen, ontdekken, lookup). Deze pagina vernieuwt automatisch.
      </p>
      {error && <div className="alert error">{error}</div>}
      <div className="panel" style={{ padding: 0, overflow: 'auto' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Status</th>
              <th>Voortgang</th>
              <th>Bericht</th>
              <th>Gestart</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((j) => (
              <tr key={j.id}>
                <td>
                  <code>{j.type}</code>
                </td>
                <td>
                  <StatusBadge status={j.status} />
                </td>
                <td style={{ minWidth: 140 }}>
                  <div className="progress">
                    <span style={{ width: `${j.progress}%` }} />
                  </div>
                  <div className="muted" style={{ fontSize: '0.78rem', marginTop: 4 }}>
                    {j.progress}%
                  </div>
                </td>
                <td className="muted">{j.error || j.progressMessage || '—'}</td>
                <td className="muted">{j.startedAt ? formatDateTime(j.startedAt) : formatDateTime(j.createdAt)}</td>
              </tr>
            ))}
            {jobs.length === 0 && (
              <tr>
                <td colSpan={5} className="empty">
                  Nog geen jobs.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
